import { useState } from "react";
import { Copy, Check } from "lucide-react";

const CodeBlock = ({ children }) => {

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {

    try {

      await navigator.clipboard.writeText(children);

      setCopied(true);

      setTimeout(() => setCopied(false), 2000);

    } catch (err) {
      console.error(err);
    }

  };

  return (

    <div className="relative my-6 rounded-lg overflow-hidden border border-neutral-800">

      <div className="flex justify-end px-3 py-2 text-xs bg-neutral-900 text-neutral-400">

        <button
          onClick={handleCopy}
          className="flex items-center gap-1 hover:text-white"
        >

          {copied ? (
            <>
              <Check className="w-3 h-3" />
              Copied
            </>
          ) : (
            <>
              <Copy className="w-3 h-3" />
              Copy
            </>
          )}

        </button>

      </div>

      <pre className="p-4 overflow-x-auto text-sm">

        <code>{children}</code>

      </pre>

    </div>

  );

};

export default CodeBlock;
